//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.type.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.IntAdapter
import com.apollographql.apollo.api.Optional
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.list
import com.apollographql.apollo.api.nullable
import com.apollographql.apollo.api.present
import com.wintermar.inspection.graphql.type.GetInspectionListQueryInput
import kotlin.IllegalStateException

public object GetInspectionListQueryInput_InputAdapter : Adapter<GetInspectionListQueryInput> {
  override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): GetInspectionListQueryInput = throw IllegalStateException("Input type used in output position")

  override fun toJson(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    `value`: GetInspectionListQueryInput,
  ) {
    writer.name("page")
    IntAdapter.toJson(writer, customScalarAdapters, value.page)
    writer.name("pageSize")
    IntAdapter.toJson(writer, customScalarAdapters, value.pageSize)
    if (value.status is Optional.Present) {
      writer.name("status")
      InspectionStatus_ResponseAdapter.list().nullable().present().toJson(writer, customScalarAdapters, value.status)
    }
  }
}
